import { render, staticRenderFns } from "./CommutesDistancesBar.vue?vue&type=template&id=4596a34b"
import script from "./CommutesDistancesBar.vue?vue&type=script&lang=js"
export * from "./CommutesDistancesBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports